module.exports = __webpack_public_path__ + "img/phone.81ebcb7d.svg";